import React from 'react';
import { borderStyleConstants } from '../../constants/borderStyle';
import { useSafeSelector } from '../../hooks/useSafeSelector';

export interface ModalViewProps {
  children: React.ReactNode[] | React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/ban-types
  showModal: boolean | undefined;
  onClose: (() => void) | undefined;
  customStyle?: { [key: string]: any };
  loading?: boolean;
}

export function ModalView(props: ModalViewProps) {
  const { onClose, showModal, children, customStyle, loading } = props;
  const stopPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };
  const { borderStyle } = useSafeSelector((state: any) => state.customization);

  const handleClose = () => {
    if (loading) return;
    onClose?.();
  };

  return (
    <>
      {showModal && (
        <div
          onClick={handleClose}
          className="fixed inset-0 bg-gray-700/25 backdrop-blur-[8px] flex justify-center items-center z-10"
        >
          <div
            onClick={stopPropagation}
            className="relative w-auto max-h-full mobile:w-11/12"
          >
            <div
              className={`relative bg-white shadow ${
                borderStyle === borderStyleConstants.RECTANGULAR
                  ? 'rounded-none'
                  : 'rounded-lg'
              }`}
              style={{ borderRadius: customStyle?.['borderRadius'] || '', backgroundColor: customStyle?.['backgroundColor'] || ''  }}
            >
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ModalView;
